import { postCanceled } from '../api/postCanceled';
import { setGetFreespin } from './setGetFreespin';

const setPostCanceled = (params, setCode) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postCanceled(params);
            dispatch(setGetFreespin(params, setCode));
            alert('Freespin отменен')
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostCanceled
}